import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledParagraph = makeDefaultTypographyStyled(
  'Paragraph',
  'p',
  1,
  1.46,
);
